import React, { Component } from "react";
import * as XLSX from 'xlsx-js-style';
import close_btn from '../../../images/close_btn.svg';
import { userService } from "../../../_services";
import $ from 'jquery';
//import moment, { relativeTimeRounding } from 'moment';Commented because not in use

class ComissionPayoutReport extends Component {
    constructor(props) {
        super(props);

        this.state = {
            login_page: false,
            monthsList: [],
            loader: true,
            error: ''
        };
        this.reportData = this.reportData.bind(this);
        this.downloadReport = this.downloadReport.bind(this);
    }
    componentDidMount() {
        $('body').css('overflow-y', 'hidden');
        let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        this.getCommisionMonthsList(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1])

        this.setState({ loader: false });
    }
    getCommisionMonthsList = (Userid, userrole) => {
        try {
            userService.FetchPayoutReportMonth(Userid, userrole)
                .then(apidata => {
                    if (apidata.length > 0) {

                        this.setState({ monthsList: apidata, loader: false, error: '' });
                    }
                });
        }
        catch (err) {
            this.setState({ loader: false, error: 'Oops! Something went wrong. Please try again later.' });
        }
    }

    reportData(e) {
        try {
            e.preventDefault();
            this.downloadReport();
            e.preventDefault();
        }
        catch (error) { }
    }
    downloadFile = (data, month) => {
        const ws = XLSX.utils.json_to_sheet(data);

        const range = XLSX.utils.decode_range(ws['!ref']);

        for (let R = range.s.r; R <= range.e.r; ++R) {
            for (let C = range.s.c; C <= range.e.c; ++C) {
                const cell_address = { c: C, r: R };
                const cell_ref = XLSX.utils.encode_cell(cell_address);
                if (!ws[cell_ref]) continue;

                // Header style
                if (R === 0) {
                    ws[cell_ref].s = {
                        fill: { patternType: "solid", fgColor: { rgb: "4F81BD" } },
                        font: { bold: true, color: { rgb: "FFFFFF" } }
                    };
                }
                // Odd rows (1st data row, 3rd, etc.)
                else if (R % 2 === 1) {
                    ws[cell_ref].s = {
                        fill: { patternType: "solid", fgColor: { rgb: "DBE5F1" } }
                    };
                }
                // Even rows (2nd data row, 4th, etc.)
                else {
                    ws[cell_ref].s = {
                        fill: { patternType: "solid", fgColor: { rgb: "B8CCE4" } }
                    };
                }
            }
        }

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "User Tier Report");

        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

        const s2ab = s => {
            const buf = new ArrayBuffer(s.length);
            const view = new Uint8Array(buf);
            for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
            return buf;
        };

        const blob = new Blob([s2ab(wbout)], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        const a = document.createElement('a');
        a.download = `NuLifeSpanRx_Commission_Payout_Report_${month.trim().split(',').join('_')}.xlsx`;
        a.href = URL.createObjectURL(blob);
        a.click();
        a.remove();
    };
    downloadReport() {
        let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        this.setState({ loader: true, error: '' });
        let month = $('#Bin').val();

        try {
            userService.FetchPayoutReportLogs(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1], month)
                .then(response => {
                    var tableData = [];
                    for (var i = 0; i < response.length; i++) {
                        let dataRow = {};
                        try {
                            dataRow = {
                                "RecipientCompanyAssignedUniqueKey(primary group)": response[i].primary_Group,
                                'Additionalgroups': response[i].additionalgroups,
                                "FirstName": response[i].firstName,
                                "LastName": response[i].lastName,
                                "RecipientNotificationEmailAddress": response[i].emailAddress,
                                "Earned Commission": response[i].earned_Commission,
                                "Commission for Sub Distributor": response[i].commission_for_SubDist,
                                'Commission Due to Distributor': response[i].commission_Due_to_Distributor,
                                'Actual Earned Commission': response[i].actual_Earned,
                                'Avalara W9 Tax Status': response[i].avalaraW9Tax_Status,
                                "Wise Account Status": response[i].wiseAccount_Status,
                                "PQ Invite Status": response[i].pqInvite_Status,
                                "PQ Registration Status": response[i].pqRegistration_Status,
                            }
                        }
                        catch (error) {
                            dataRow.push("");
                        }
                        tableData.push(dataRow);
                    }
                    this.downloadFile(tableData, month.split('T')[0]);
                    this.setState({ loader: false, error: '' });

                }, 500)
        }
        catch (err) {
            this.setState({ loader: false, error: 'Oops! Something went wrong. Please try again later.' });
        }
    }

    render() {
        const { error, loader } = this.state;
        return (
            <div className="add_url_pop">
                <div className="signuparea">
                    <div className="header">
                        {this.props.title} Report
                        <div className="close" onClick={this.props.downloadCloseComissionReport}>
                            <img src={close_btn} alt="" />
                        </div>
                        {
                            loader ? <span className="loader">&nbsp;</span> : null
                        }
                    </div>
                    <div className="content">
                        <div className="main">
                            <div className="new-column">
                                <div className="same-on">
                                    <label>Choose Date</label>
                                    <span className="down-arrow"></span>
                                    <select id="Bin" className="form-control">

                                        {
                                            this.state.monthsList.map((item, dataIndex) => {
                                                return <option value={item.date_Month} key={dataIndex} > {item.date_Month}</option>
                                            })
                                        }

                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="footer">
                            <div onClick={loader ? null : this.reportData} className={loader ? "yes_btn disabled" : "yes_btn"}>Download</div>
                            <div onClick={this.props.downloadCloseComissionReport} className="no_btn">Cancel</div>
                            {
                                error &&
                                <div className="error">{error}</div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default ComissionPayoutReport;